/**
 * Masks an email address for privacy
 * Example: "user@example.com" -> "u****@example.com"
 */
export function maskEmail(email: string): string {
  if (!email?.includes("@")) {
    return email;
  }

  const [localPart, domain] = email.split("@");

  if (localPart.length === 0) {
    return email;
  }

  // Show first character, mask the rest
  const maskedLocal = localPart[0] + "*".repeat(Math.max(1, localPart.length - 1));

  return `${maskedLocal}@${domain}`;
}

/**
 * Masks a phone number for privacy
 * Example: "07123456789" -> "07*****89"
 */
export function maskPhone(phone: string | undefined | null): string {
  if (!phone) {
    return "";
  }

  // Remove any non-digit characters
  const digits = phone.replace(/\D/g, "");

  if (digits.length <= 4) {
    return "*".repeat(digits.length);
  }

  // Show first 2 digits and last 2 digits, mask the middle
  const firstTwo = digits.slice(0, 2);
  const lastTwo = digits.slice(-2);
  const middleLength = digits.length - 4;

  return `${firstTwo}${"*".repeat(middleLength)}${lastTwo}`;
}
